<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39.27 39.27">
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <g>
                    <rect width="39.27" height="39.27" rx="1.98" fill="#a0a0a0" />
                    <path
                        d="M35.73,11l-6-6.34a1.93,1.93,0,0,0-1.35-.52H11.85A2.38,2.38,0,0,0,9.48,6.52V8h1.75V6.52a.62.62,0,0,1,.62-.62H27.63c.58,0,.88.3.93.93v3.64A1.37,1.37,0,0,0,30.09,12h3.34a.84.84,0,0,1,.93.92V34.09a.61.61,0,0,1-.62.61H11.85a.61.61,0,0,1-.62-.61V24.33H9.48v9.76a2.38,2.38,0,0,0,2.37,2.37H33.74a2.37,2.37,0,0,0,2.37-2.37V12A1.27,1.27,0,0,0,35.73,11Z"
                        fill="#fff"
                    />
                    <g>
                        <rect x="2.13" y="9.55" width="13.45" height="1.94" rx="0.97" transform="translate(17.71 21.03) rotate(-180)" fill="#fff" />
                        <rect x="6.05" y="12.57" width="9.54" height="1.94" rx="0.85" transform="translate(21.63 27.08) rotate(180)" fill="#fff" />
                        <rect x="9.73" y="15.59" width="5.85" height="1.94" rx="0.67" transform="translate(25.32 33.13) rotate(180)" fill="#fff" />
                    </g>
                    <g>
                        <g>
                            <rect x="14.07" y="21.23" width="17.85" height="9.77" fill="none" stroke="#fff" stroke-width="0.26" />
                            <line x1="14.07" y1="29.37" x2="31.92" y2="29.37" fill="none" stroke="#fff" stroke-width="0.26" />
                            <line x1="14.07" y1="27.74" x2="31.92" y2="27.74" fill="none" stroke="#fff" stroke-width="0.26" />
                            <line x1="14.07" y1="26.11" x2="31.92" y2="26.11" fill="none" stroke="#fff" stroke-width="0.26" />
                            <line x1="14.07" y1="24.48" x2="31.92" y2="24.48" fill="none" stroke="#fff" stroke-width="0.26" />
                            <line x1="14.07" y1="22.85" x2="31.92" y2="22.85" fill="none" stroke="#fff" stroke-width="0.26" />
                            <line x1="30.06" y1="21.23" x2="30.06" y2="31" fill="none" stroke="#fff" stroke-width="0.25" />
                            <line x1="28.21" y1="21.23" x2="28.21" y2="31" fill="none" stroke="#fff" stroke-width="0.25" />
                            <line x1="26.35" y1="21.23" x2="26.35" y2="31" fill="none" stroke="#fff" stroke-width="0.25" />
                            <line x1="24.5" y1="21.23" x2="24.5" y2="31" fill="none" stroke="#fff" stroke-width="0.25" />
                            <line x1="22.64" y1="21.23" x2="22.64" y2="31" fill="none" stroke="#fff" stroke-width="0.25" />
                            <line x1="20.79" y1="21.23" x2="20.79" y2="31" fill="none" stroke="#fff" stroke-width="0.25" />
                            <line x1="18.94" y1="21.23" x2="18.94" y2="31" fill="none" stroke="#fff" stroke-width="0.25" />
                            <line x1="17.08" y1="21.23" x2="17.08" y2="31" fill="none" stroke="#fff" stroke-width="0.25" />
                        </g>
                        <rect x="13.95" y="19.19" width="18.08" height="2.06" fill="#fff" />
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>
<script>
export default {};
</script>



// WEBPACK FOOTER //
// XlsFileIcon.vue?07c24232